<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
        <el-input
          class="search-el"
          size="mini"
          v-model="query.search"
          placeholder="商品/昵称/手机号"
        ></el-input>
        <el-select
          class="search-el"
          size="mini"
          v-model="query.object_id"
          placeholder="请选择小组"
          filterable
          v-if="showQuerySelect"
        >
          <el-option label="全部小组" value=""></el-option>
          <el-option
            v-for="item in groupList"
            :key="item.id"
            :label="item.number + '组【' + item.title + '】'"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          class="search-el"
          size="mini"
          v-model="query.present"
          placeholder="请选择"
          filterable
        >
          <el-option label="全部状态" value=""></el-option>
          <el-option label="已签到" value="1"></el-option>
          <el-option label="未签到" value="0"></el-option>
        </el-select>
        <el-select
          class="search-el"
          size="mini"
          v-model="query.xueyuanshenfen"
          placeholder="请选择学员身份"
          filterable
        >
          <el-option label="全部学员" value=""></el-option>
          <el-option label="复训" value="1"></el-option>
          <el-option label="赠送" value="2"></el-option>
          <el-option label="新生" value="3"></el-option>
        </el-select>
        <el-button type="primary" size="mini" @click="fenrun = 0;getList()">
          查询
        </el-button>
        <el-button type="primary" size="mini" @click="createInfo()">
          添加
        </el-button>
        <el-button
          type="primary"
          size="mini"
          @click="dialogVisibleImport = true"
        >
          导入
        </el-button>
        <el-button type="primary" size="mini" @click="exportOrder()">
          导出
        </el-button>
        <el-button type="warning" size="mini" @click="fenrun = 1;getList()">分润</el-button>
        
        <i class="el-icon-info" @click="fuxunMsg()"></i>

        <el-button type="danger" size="mini" @click="delAllStudent()">
          清空列表
        </el-button>

            <el-button type="warning" size="mini" v-if="multipleSelection.length > 0" @click="multiShare()">分润批量操作</el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="fenrun == 1"
          type="selection"
          width="55"
          :selectable="disabledCheckBox">
        </el-table-column>
        <el-table-column
          prop="order_id"
          label="订单ID"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
          label="用户昵称"
          align="center"
          min-width="10%"
        >
        <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toUpdate(row)">
              <div>{{ row.nickname }}</div>
            </el-button>
        </template>
        </el-table-column>
        <el-table-column
          prop="mobile_phone"
          label="灵动生活手机号"
          align="center"
          min-width="10%"
        ></el-table-column>
        <el-table-column
          prop="agent_name"
          label="用户归属"
          align="center"
          min-width="10%"
        ></el-table-column>
        <el-table-column
          prop="extra.xueyuanxingming"
          label="姓名"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="extra.xueyuanshoujihao"
          label="手机号"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="order_no"
          label="订单号"
          align="center"
          min-width="13%"
        ></el-table-column>

        <el-table-column
          prop="extra.liuliangguishu"
          label="流量归属"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="extra.xiaoshouguishu"
          label="销售归属"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="extra.xueyuanshenfen"
          label="学员身份"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="extra.yaoyueren"
          label="邀约人"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
            prop="agent_share_status_msg"
            label="状态"
            align="center"
            min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="body"
          label="内容"
          align="center"
          min-width="13%"
        ></el-table-column>
        <el-table-column
          prop="price"
          label="订单价格"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
          prop="total_amount"
          label="实付金额"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
          prop="paid_at"
          label="完成时间"
          align="center"
          min-width="10%"
        ></el-table-column>

        <el-table-column
          prop="object_id"
          label="小组"
          align="center"
          min-width="8%"
        >
          <template slot-scope="{ row }">
            <el-select
              ref="multiSelect"
              class="search-el"
              size="mini"
              v-model="row.object_id"
              placeholder="请选择小组"
              filterable
              @change="meetGrouping($event, row.id)"
            >
              <el-option
                v-for="item in groupList"
                :key="item.id"
                :label="item.number + '组【' + item.title + '】'"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column
            prop="hx_agent_name"
            label="核销代理商"
            align="center"
            min-width="11%"
        ></el-table-column>

        <el-table-column
            prop="share_amount"
            label="分润金额"
            align="center"
            min-width="11%"
        ></el-table-column>

        <el-table-column
          prop="sign_in"
          label="现场签到"
          align="center"
          min-width="11%"
        ></el-table-column>

        <el-table-column label="操作" align="center" min-width="13%">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="mini"
              @click="
                row.present == 1
                  ? studentListSet(row.id, 0, row.present_msg)
                  : studentListSet(row.id, 1, row.present_msg)
              "
            >
              <div>{{ row.present_msg }}</div>
            </el-button>

            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              :disabled="row.agent_share_status == 2"
              @click="studentListDelete(row.id)"
            >
            </el-button>

            <el-button v-if="fenrun == 1 && [2].indexOf(row.status) >= 0 && row.total_amount > 0 && row.is_show_button == 1" size="mini" type="warning" @click="onceShare(row.id, row.total_amount)">确认分润</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
      title="添加学员"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="addEditFormOnClose"
      width="50%"
    >
      <el-form :model="topicTemp" label-width="100px" class="demo-ruleForm">
        <el-form-item label="订单号" prop="name">
          <label slot="label"><span style="color:red">*</span>订单号</label>
          <el-input
            v-model="topicTemp.order_no"
            maxlength="48"
            show-word-limit
            placeholder="请输入订单号"
            :disabled="this.agent_share_status == 2"
          ></el-input>
        </el-form-item>
        <el-form-item label="小组">
          <label slot="label"><span style="color:red">*</span>小组</label>
          <el-select
            class="search-el"
            size="small"
            v-model="topicTemp.object_id"
            placeholder="销售"
          >
            <el-option
              v-for="item in groupList"
              :key="item.id"
              :label="item.number + '组【' + item.title + '】'"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="姓名" prop="extra.xueyuanxingming">
          <label slot="label"><span style="color:red">*</span>姓名</label>
          <el-input
            v-model="topicTemp.extra.xueyuanxingming"
            maxlength="10"
            show-word-limit
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="extra.xueyuanshoujihao">
          <label slot="label"><span style="color:red">*</span>手机号</label>
          <el-input
            v-model="topicTemp.extra.xueyuanshoujihao"
            maxlength="15"
            show-word-limit
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>

        <el-form-item label="流量归属" prop="extra.liuliangguishu">
          <el-input
            v-model="topicTemp.extra.liuliangguishu"
            maxlength="8"
            show-word-limit
            placeholder="请输入流量归属"
          ></el-input>
        </el-form-item>
        <el-form-item label="销售归属" prop="extra.xiaoshouguishu">
          <el-input
            v-model="topicTemp.extra.xiaoshouguishu"
            maxlength="8"
            show-word-limit
            placeholder="请输入销售归属"
          ></el-input>
        </el-form-item>
        <el-form-item label="学员身份" prop="extra.xueyuanshenfen">
          <el-input
            v-model="topicTemp.extra.xueyuanshenfen"
            maxlength="8"
            show-word-limit
            placeholder="请输入学员身份"
          ></el-input>
        </el-form-item>
        <el-form-item label="邀约人" prop="extra.yaoyueren">
          <el-input
            v-model="topicTemp.extra.yaoyueren"
            maxlength="8"
            show-word-limit
            placeholder="请输入邀约人"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="createTopic()"
            :loading="updateLoading"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 上传导入 -->
    <el-dialog
      title="导入"
      :visible.sync="dialogVisibleImport"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
    >
      <el-upload
        class="upload-demo"
        :action="ossAction"
        :show-file-list="false"
        :http-request="uploadOSSRequest"
      >
        <el-button size="mini" type="primary">导入</el-button>
        <div slot="tip" class="el-upload__tip">
          <el-link
            :underline="false"
            type="primary"
            href="https://res.defen.hzxinquanzi.com/activity/%E5%B9%B8%E7%A6%8F%E4%B9%8B%E6%97%85%E5%AD%A6%E5%91%98%E5%88%97%E8%A1%A8%E6%A8%A1%E6%9D%BF.xlsx?v=1"
            target="_blank"
            >下载模板文件</el-link
          >
          <p>1.请下载模板文件</p>
          <p>2.补充填入所需数据</p>
          <p>3.用户姓名、手机号、小组不能为空</p>
          <p>4.电话号、订单号必须确保正常显示，禁止 科学计数法</p>
          <p>5.每个单元格只能有一个数据</p>
          <p>6.禁止空行数据</p>
          <p>7.保存上传</p>
        </div>
      </el-upload>
    </el-dialog>

    <div class="hides" v-if="updateLoading" style="position: relative; z-index: 5000; opacity: 0.2;">
      <i style="margin-top: 20px; font-size: 40px" class="el-icon-loading"> </i
      ><br />
      正在上传
    </div>
  </div>
</template>

<script>
import { uploadOSSRequest, getAliyunOssToken } from "@/api/common";

const axios = require('axios');

import {
  meetXfStudentList,
  meetGroupList,
  importOrderToGroupXf,
  importStudentListXf,
  studentListSet,
  studentListDelete,
  delAllStudent,
  meetGrouping,
  relationStudentCancelShare,
  relationStudentMultiCancelShare,
} from "@/api/activity";

import { RSAEncrypt } from "@/api/common";

export default {
  data: function () {
    return {
      ossAction: "",
      dialogVisibleImport: false,
      activityId: 0,
      dialogVisible: false,
      create: false,
      meetObjectId: "请选择小组",
      showQuerySelect: true,
      groupList: [],
      list: [],
      loading: false,
      updateLoading: false,
      total: 0,
      agent_share_status: 0,
      fenrun: 0,
      query: {
        page: 1,
        limit: 20,
        activity_id: 0,
        object_id: 0,
        present: "",
        search: "",
        xueyuanshenfen: '',
      },
      updateRelation: false,
      topicTemp: {
        id: 0,
        activity_id: 0,
        order_no: "",
        object_id: "请选择小组",
        extra: {
          liuliangguishu: "",
          xiaoshouguishu: "",
          xueyuanshenfen: "",
          xueyuanxingming: "",
          xueyuanshoujihao: "",
          yaoyueren: "",
        },
      },

      multipleSelection: [],
    };
  },
  created: function () {
    this.activityId = parseInt(this.$route.query.activity_id);
    this.query.activity_id = this.activityId;
    this.query.object_id = this.$route.query.object_id;
    this.topicTemp.activity_id = this.activityId;
    if (this.$route.query.object_id != undefined) {
      this.showQuerySelect = false;
    }
  },
  methods: {
    disabledCheckBox(row, index) {
      if (this.fenrun == 1 && [2].indexOf(row.status) >= 0 && row.total_amount > 0 && row.is_show_button == 1) {
        return true;
      } else {
        return false;
      }
    },
    multiShare() {
      var arr = [];
      this.$refs.multipleTable.selection.forEach(row => {
        arr.push({
          id: RSAEncrypt(row.id),
          total_amount: row.total_amount,
        })
      });
      console.log(arr)

      this.$confirm("是否将选中的数据进行分润操作？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          relationStudentMultiCancelShare({
            arr: arr,
            activity_id: this.activityId,
          }).then((response) => {
            if (response.status == 2000) {
              this.$alert(response.message, "处理结果", {
                confirmButtonText: "确定",
                type: "info",
              })
                .then(() => {})
                .catch(() => {});
              this.fenrun = 1; this.getList()
            }
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onceShare(id, total_amount) {
      this.$confirm("是否进行分润操作？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          relationStudentCancelShare({
            id: RSAEncrypt(id),
            price: total_amount,
            activity_id: this.activityId,
          }).then((response) => {
            if (response.status == 2000) {
              this.$message({
                showClose: true,
                message: "成功",
                type: "success",
              });
              this.dialogVisible = false;
              this.fenrun = 1; this.getList()
            }
          });
        })
        .catch(() => {});
    },
    fuxunMsg() {
      this.$message({
          dangerouslyUseHTMLString: true,
          message: '一键查询可分润学员列表（查询条件为 学员列表中购买幸福之旅正价票订单的学员）'
        });
    },
    toUpdate(row) {
      this.tempReset();
      this.updateRelation = true;
      this.topicTemp.id = row.id;
      this.topicTemp.activity_id = this.activityId;
      this.topicTemp.order_no = row.order_no;
      this.topicTemp.order_id = row.order_id;
      this.topicTemp.object_id = row.object_id;
      this.agent_share_status = row.agent_share_status;

      if (row.extra != null) {
        if ('liuliangguishu' in row.extra) this.topicTemp.extra.liuliangguishu = row.extra.liuliangguishu;
        if ('xiaoshouguishu' in row.extra) this.topicTemp.extra.xiaoshouguishu = row.extra.xiaoshouguishu;
        if ('xueyuanshenfen' in row.extra) this.topicTemp.extra.xueyuanshenfen = row.extra.xueyuanshenfen;
        if ('xueyuanxingming' in row.extra) this.topicTemp.extra.xueyuanxingming = row.extra.xueyuanxingming;
        if ('xueyuanshoujihao' in row.extra) this.topicTemp.extra.xueyuanshoujihao = row.extra.xueyuanshoujihao;
        if ('yaoyueren' in row.extra) this.topicTemp.extra.yaoyueren = row.extra.yaoyueren;
      }
      this.dialogVisible = true;
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.dialogVisible = false;      
    },

    uploadOSSRequest(file) {
      this.updateLoading = true;
      getAliyunOssToken({ dir: "activity/" + this.activityId + "/" }).then(
        (res) => {
          uploadOSSRequest(file.file, res.data).then((fileUrl) => {
            importStudentListXf({
              activity_id: this.activityId,
              url: fileUrl,
            }).then((res) => {
              if (res.status == 2000) {
                this.updateLoading = false;

                this.$confirm(res.message, "导入结果", {
                  confirmButtonText: "确定",
                  type: "info",
                })
                  .then(() => {
                    this.dialogVisibleImport = false;
                    this.getList();
                  })
                  .catch(() => {
                    this.dialogVisibleImport = false;
                    this.getList();
                  });
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error",
                });
              }
            });
          });
        }
      );
    },

    tempReset() {
      this.topicTemp = {
        id: 0,
        activity_id: this.activityId,
        order_no: "",
        object_id: "请选择小组",
        extra: {
          liuliangguishu: "",
          xiaoshouguishu: "",
          quzhang: "",
          xueyuanshenfen: "",
          xueyuanxingming: "",
          xueyuanshoujihao: "",
          yaoyueren: "",
        },
      };
    },
    getGroupList() {
      meetGroupList({
        activity_id: this.activityId,
        page: 1,
        limit: 200,
      }).then((res) => {
        if (res.status === "2000") {
          this.groupList = res.data.list;
        }
      });
    },
    createInfo() {
      this.create = true;
      this.dialogVisible = true;
      this.tempReset();
      this.getGroupList();
    },
    createTopic() {
      console.log(this.topicTemp)
      if (this.topicTemp.order_no == "") {
        this.$message.error('订单号不能为空')
        return false
      }
      if (this.topicTemp.object_id == "请选择小组") {
        this.$message.error('小组不能为空')
        return false
      }
      if (this.topicTemp.extra.xueyuanxingming == '') {
        this.$message.error('姓名不能为空')
        return false
      }
      if (this.topicTemp.extra.xueyuanshoujihao == '') {
        this.$message.error('手机号不能为空')
        return false
      }
      this.updateLoading = true;
      importOrderToGroupXf(this.topicTemp)
        .then((response) => {
          this.updateLoading = false;
          this.create = false;
          if (response.status === "2000") {
            this.tempReset();
            this.$message.success(response.message);
            this.getList();
            this.dialogVisible = false;
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },

    getList(str) {
      this.loading = true;
      meetXfStudentList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
      this.getGroupList();
    },

    studentListDelete(id) {
      this.$confirm("确定执行删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          studentListDelete({
            id: id,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },

    delAllStudent() {
      this.$confirm("确定执行清空列表吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delAllStudent({
            activity_id: this.activityId,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "清空列表成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },

    studentListSet(id, type, msg) {
      this.$confirm("确定要设置为" + msg + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          studentListSet({
            id: id,
            present: type,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },

    meetGrouping(event, id) {
      this.$confirm("确定要更改小组吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        meetGrouping({
          id: id,
          object_id: event,
        })
          .then((response) => {
            if (response.status == 2000) {
              setTimeout(() => {
                this.$refs.multiSelect.blur();
              }, 50);
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            }
          });
      }).catch(() => {});
    },

    exportOrder() {
      this.query.is_export = 1;
      this.loading = true;

      axios({
        method: 'post',
        url: '/backend/activity/meetXfStudentList',
        data: this.query,
        responseType: 'blob'
      }).then((res) => {
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '幸福之旅学员.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loading = false;
        this.query.is_export = 0;
      }).catch(error => {
        this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
        })
        console.log(error)
      })
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style>
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
</style>